module.exports = __webpack_public_path__ + "static/media/Road-bike-frame-size.4fc79d10.png";